module.exports = __webpack_public_path__ + "static/media/umy_chang.470fa320.jpg";